import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CalendarIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.6667 2.5V5.16667M5.33341 2.5V5.16667M2.66675 7.83333H13.3334M2.66675 5.16667C2.66675 4.81304 2.80722 4.47391 3.05727 4.22386C3.30732 3.97381 3.64646 3.83333 4.00008 3.83333H12.0001C12.3537 3.83333 12.6928 3.97381 12.9429 4.22386C13.1929 4.47391 13.3334 4.81304 13.3334 5.16667V13.1667C13.3334 13.5203 13.1929 13.8594 12.9429 14.1095C12.6928 14.3595 12.3537 14.5 12.0001 14.5H4.00008C3.64646 14.5 3.30732 14.3595 3.05727 14.1095C2.80722 13.8594 2.66675 13.5203 2.66675 13.1667V5.16667Z"
          stroke="#5D708C"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.3335 10.5H6.66683V11.8333H5.3335V10.5Z"
          fill="#5D708C"
          stroke="#5D708C"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
